// extracted by mini-css-extract-plugin
export default {"cls1":"CoreXNav-cls1___8db60a0379ec940f5a9","cls2":"CoreXNav-cls2___987e2000be238d91e1a CoreXNav-cls1___8db60a0379ec940f5a9"};